module.exports = __webpack_public_path__ + "img/abw.47ea7038.svg";